import { render, staticRenderFns } from "./ReportTitle.vue?vue&type=template&id=b722e5ec&"
import script from "./ReportTitle.vue?vue&type=script&lang=js&"
export * from "./ReportTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports